import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSKU } from 'hooks/useSKU';

import { useAppSelector } from 'store/hooks';
import { washhubSelector } from 'store/slices/washhub';

import { createCase } from 'api/items';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { RefType, AddCaseModalProps } from './AddCaseModal.props';

import AddCaseModalView from './AddCaseModal.view';
import { washHub } from 'store/slices';

const Container = forwardRef<RefType, AddCaseModalProps>((_, ref) => {
  const queryClient = useQueryClient();
  const washHubs = useAppSelector(washhubSelector);
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: skus = [], isLoading: isLoadingSKU } = useSKU(
    'case',
    washHubId,
  );

  const { mutate, isLoading } = useMutation(createCase, {
    onSuccess: () => {
      successToast('Case created successfully');

      queryClient.invalidateQueries(`fetch-cases-${washHubId}`);

      queryClient.invalidateQueries(`fetch-case-history-${washHubId}`);

      queryClient.invalidateQueries(`fetch-cases-status-count-${washHubId}`, {
        exact: true,
      });

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [],
  );

  const onSubmit = (values: any) => {
    const skuCode = skus?.find((s) => s._id === values?.sku)?.code;
    const washHubCode = washHubs?.find((w) => w._id === washHubId)?.code;

    values = {
      washHub: washHubId,
      washHubCode,
      skuCode,
      sku: values?.sku,
      rfids: values?.rfids,
    };
    console.log(values);

    mutate(values);
  };

  const _props = {
    skus,
    isOpen,
    onClose,
    onSubmit,
    washHubs,
    isLoading,
    isLoadingSKU,
  };

  return <AddCaseModalView {..._props} />;
});

const AddCaseModal = memo(Container);

export default AddCaseModal;
